// Where each launch-readiness finding is fixed: a field on this page (target), another page (link),
// a one-click change (quick), or a server key (server).
const DELIVERY = { link: "/delivery", linkLabel: "Open Delivery" };

const FIXES = {
  destination_missing: { target: "custom-lp-destination" },
  destination_not_found: { target: "custom-lp-destination" },
  destination_inactive: { target: "custom-lp-destination", ...DELIVERY },
  destination_config_empty: DELIVERY,
  destination_url_missing: DELIVERY,
  destination_email_missing: DELIVERY,
  firm_name_missing: { target: "custom-lp-firm-name" },
  slug_missing: { quick: { label: "Save now", patch: {} } },
  vertical_missing: { target: "custom-lp-vertical-select" },
  hero_headline_missing: { target: "custom-lp-hero-headline" },
  hero_image_missing: { target: "custom-lp-hero-url", quick: { label: "No image needed", patch: { no_hero_image: true } } },
  cta_text_missing: { target: "custom-lp-cta-text" },
  thankyou_missing: { target: "custom-lp-thankyou-headline" },
  tcpa_language_missing: { target: "custom-lp-tcpa" },
  privacy_url_missing: { target: "custom-lp-privacy-url" },
  terms_url_missing: { target: "custom-lp-terms-url" },
  consumer_consent_disabled: { quick: { label: "Turn consent back on", patch: { consumer_consent_enabled: true } } },
  state_allowlist_missing: { target: "custom-lp-state-picker", quick: { label: "Accept all states", patch: { all_states: true } } },
  pixels_use_global_but_empty: {
    link: "/admin/pixels", linkLabel: "Add pixels",
    quick: { label: "No pixels on this page", patch: { pixels_intentionally_disabled: true } },
  },
  pixels_overrides_empty: { target: "custom-lp-pixels-section" },
  buyer_price_missing: DELIVERY,
  return_window_missing: DELIVERY,
  vendor_cost_missing: { link: "/affiliates", linkLabel: "Open Affiliates" },
  no_test_or_prior_lead: { target: "custom-lp-test-dest-primary" },
  quiz_contact_step_missing: { target: "quiz-config-panel" },
  quiz_consent_step_missing: { target: "quiz-config-panel" },
  quiz_intro_missing: { target: "quiz-config-panel" },
  trustedform_not_configured: { server: true },
  turnstile_not_configured: { server: true },
  bot_defense_disabled: { server: true },
};

export const fixFor = (code) => FIXES[code] || (code.startsWith("focused_funnel") ? { target: "focused-funnel-config-panel" } : null);

const FLASH = ["ring-4", "ring-amber-400", "ring-offset-2"];

// Scroll to a field on the editor (opening its section on phones) and flash it. False when it isn't on screen.
export function goToField(testId) {
  const el = document.querySelector(`[data-testid="${testId}"]`);
  if (!el) return false;
  const body = el.closest('[data-testid$="-body"]');
  if (body && body.classList.contains("hidden")) {
    document.querySelector(`[data-testid="${body.dataset.testid.replace(/-body$/, "-header")}"]`)?.click();
  }
  setTimeout(() => {
    el.scrollIntoView({ behavior: "smooth", block: "center" });
    el.classList.add(...FLASH);
    if (typeof el.focus === "function") el.focus({ preventScroll: true });
    setTimeout(() => el.classList.remove(...FLASH), 2600);
  }, 60);
  return true;
}
